module.exports = __webpack_public_path__ + "static/media/coveradimas.a7d7c73a.png";